import React from 'react';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';

const styles = {
    dialogContent: {
        minWidth: '20rem',
        paddingY: '1rem',
    },
    dialogTitle: {
        paddingBottom: '0.5rem',
    },
    buttonContainer: {
        display: 'flex',
        gap: '0.75rem',
        justifyContent: 'flex-end',
        padding: '1rem',
    }
};

export default function ConfirmationDialog({open, title, message, onConfirm, onCancel}) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle sx={styles.dialogTitle}>
                <Typography variant="h6">{title}</Typography>
            </DialogTitle>
            <DialogContent sx={styles.dialogContent}>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions sx={styles.buttonContainer}>
                <Button variant="contained" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="contained" color="error" onClick={onConfirm}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
